/* eslint-disable */
import React, { useEffect, useState } from "react";
import GoogleMapReact from 'google-map-react';
import '../assests/css/googleMap.css'
//import Marker from 'google-map-react';

export default function GoogleMap(props) {
    const [newCoords, setNewCoords] = useState([])

    useEffect(() => {
        // console.log("props for map", props?.data)

        const tempArray = [];
        props?.data?.filter(obj => { 
            return tempArray.push(obj.coordinate) 
        })

        setNewCoords(tempArray)
    }, [props]);

    const Marker = () => (
        <div className="marker-style"></div>
    );

    const defaultProps = {
        // center: {},
        zoom: 10,
        apikeys: { key: "AIzaSyA9JqqEm_Womt_9Zp8F6q1umHneKaiCoOY" },
        markers: []
    };
    return (
        <div>
        <div style={{ display: [newCoords.length === 0 ? 'none' : ''] }} className="map-container">
            <GoogleMapReact
                center={{
                    lat: (newCoords.length !== 0 || newCoords === undefined) ? newCoords[0].latitude : 38.605183,
                    lng: (newCoords.length !== 0 || newCoords === undefined) ? newCoords[0].longitude : -89.594186
                }}
                defaultZoom={defaultProps.zoom}
                bootstrapURLKeys={defaultProps.apikeys}
            >
                {/* <Marker
                    lat={props?.data?.latitude ? props.data.latitude : "38.605183"}
                    lng={props?.data?.longitude ? props.data.longitude:"-89.594186"}
                    text="my"
                /> */}
                {newCoords.map(marker => (
                    <Marker
                        key={marker.length}
                        lat={marker.latitude}
                        lng={marker.longitude}
                        text="my marker"
                    />
                ))}
            </GoogleMapReact>
        </div>
        </div>
    );
}
